// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import './assets/js/jQuery.js'
import moment from 'moment'//日期插件
import md5 from 'md5'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import layer from './assets/layer/layer.js'
import './assets/layer/theme/default/layer.css'

import './assets/css/config.css'
import './assets/css/style.css'
Vue.prototype.axios = axios
Vue.prototype.moment = moment
Vue.prototype.md5 = md5

//配置请求地址、文件地址、appKey、appSecret、本机地址

let localName = window.location.host, devApi,
    Url, appKey, appSecret, imgUrl = 'http://priceoss.yuncai998.com/';
switch (localName) {
    case 'kkb.yuncai998.com':
        Url = 'https://kkbapi.yuncai998.com'
        appKey = '6A0A26F3DDD'
        appSecret = '60D06AFD5EB025EE98A3C10872AF9DBB'
        imgUrl = 'http://priceoss.yuncai998.com/'
        break;
    case 'testkkb.yuncai998.com':
        Url = 'https://testkkbapi.yuncai998.com'
        appKey = '6A0A26F3DDD'
        appSecret = '60D06AFD5EB025EE98A3C10872AF9DBB'
        imgUrl = 'http://priceoss.yuncai998.com/'
        break
    case '192.168.3.199:7009':
        devApi = getUrlKey('devApi')
        if (devApi !== 'null') {
            Url = 'http://' + devApi + ':9098'
        } else {
          Url = 'http://192.168.3.199:9098'
        }
        appKey = '6A0A26F3DDD'
        appSecret = '60D06AFD5EB025EE98A3C10872AF9DBB'
        imgUrl = 'http://priceoss.yuncai998.com/'
        break
    default:
        Url = 'http://192.168.3.199:9098'
        // Url = 'https://testkkbapi.yuncai998.com'
        appKey = '6A0A26F3DDD'
        appSecret = '60D06AFD5EB025EE98A3C10872AF9DBB'
        imgUrl = 'http://priceoss.yuncai998.com/'
}
function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || 'null'
}
//图片请求
Vue.prototype.uploadImg = function (e, type, callback) {//上传文件
	var file = e.target.files[0]
	var formData = new FormData();
	formData.append('file',file);
	formData.append('type', type);
	axios({
		url: '/admin/upload/picture',
		method: 'post',
		params: {},
		data: formData
	}).then(function (response) {
		callback('true', response.data)
	}).catch(function(error) {
		callback(false)
	})
}
Vue.prototype.uploadFile = function (type, url, formData, callback) {//上传文件
	axios({
		url: url,
		method: type,
		params: {},
		data: formData
	}).then(function (response) {
      switch (response.data.status) {
        case '200':
            callback(true, response.data)
            break
        default:
            root.$message.error(response.data.msg, { duration: 2000 })
            switch (response.data.code) {
                case 'LOGIN_INVALID':
                    sessionStorage.removeItem('token')
                    if (root.$route.path === '/login') {
                        callback(false)
                    } else {
                        root.goPath('/login')
                    }
                    break
                default:
                    callback(false)
                    break
            }
            break
    }
	}).catch(function(error) {
		callback(false)
	})
}
//公共请求
Vue.prototype.$http = function (type, httpUrl, params, data, callback) {
    // if (JSON.stringify(params) === '{}') {
    //   params = null
    // }
    // if (JSON.stringify(data) === '{}') {
    //   data = null
    // }
    axios({
      method: type,
      url: httpUrl,
      params: params,
      data: data
    }).then( (response) => {
        //处理服务器返回状态码
        switch (response.data.status) {
          case '200':
            callback(true, response.data)
            break
          default:
            if (response.data.message) {
              root.$message.error(response.data.message, {duration: 2000})
            } else {
              root.$message.error(response.data.error, {duration: 2000})
            }
            switch (response.data.code) {
              case 'LOGIN_INVALID':
                sessionStorage.removeItem('token')
                if (root.$route.path === '/login') {
                  callback(false, response.data)
                } else {
                  root.goPath('/login')
                }
                break
              case 'TIMEOUT'://超时
                  sessionStorage.removeItem('token')
                  if (root.$route.path === '/login') {
                    callback(false, response.data)
                  } else {
                    root.goPath('/login')
                  }
                  break
              case 'LOGIN_FAIL'://登录失败
                  sessionStorage.removeItem('token')
                  if (root.$route.path === '/login') {
                    callback(false, response.data)
                  } else {
                    root.goPath('/login')
                  }
                  break
              default:
                callback(false, response.data)
                break
            }
            break
        }
    }).catch( (error) => {
      console.log('error........',error);
      root.$message.error(error.response.data.msg, {duration: 5000})
    })
}

axios.interceptors.request.use( config => {
 
    let textSign = config.url;
    //排列参数params
    if ( config.params != undefined) {
      let keys = [];
      $.each(config.params, el => {
        keys.push(el);
      });
      //参数key排列
      for ( let i=0; i < keys.length - 1; i++ ) {
        for (let j = 0; j < keys.length - 1 - i; j++) {
          let total_1 = 0;
          let charKeys = keys[j].split('')
          for (let index in charKeys) {
            total_1 += charKeys[index].charCodeAt()
          }

          let total_2 = 0;
          charKeys = keys[j + 1].split('')
          for (let index in charKeys) {
            total_2 += charKeys[index].charCodeAt()
          }

          if (total_1 > total_2) {
            let temp = keys[j]
            keys[j] = keys[j + 1]
            keys[j + 1] = temp
          }
        }
      }
      let params = ""
      for (let index in keys) {
        params += keys[index] + config.params[keys[index]]
      }
      textSign += params
    }
    //排列参数data
    if (config.data != undefined) {
      textSign += JSON.stringify(config.data)
    }

    //拼接时间蹉
    let time = moment(new Date()).valueOf()
	  textSign += time
    //拼接appSecret
    textSign += appSecret

    let sign = md5(textSign).toUpperCase() //md5加密并转成大写

    //设置最终请求地址
    config.url = Url + config.url
    axios.defaults.headers['Content-Type']
    config.headers = {
      'App-Id': appKey,
      'Request-Timestamp': time,
      'Request-Signature': sign,
      'Request-Token': sessionStorage.getItem('token')
    }
    return config

}, error => {
  //对请求错误做些什么
  return Promise.reject(error)
});

//页面title设置
router.afterEach( function (to) {
  document.title = to.name
});

Vue.prototype.confirm = function (text, callback) {
  layer.confirm(text, {
    btn: ['确定', '取消'],
    title: '提示'
  }, function (index) {
    callback(index)
  }, function () {

  })
}
Vue.prototype.load = function () {
  return  this.$loading({
    lock: true,
    text: '加载中',
    spinner: 'el-icon-loading',
    background: 'rgba(255, 255, 255, 0.7)'
  });  
}
Vue.prototype.msg = function (text, time) {
  //time单位:毫秒
  layer.msg(text, {time: time});
}



Vue.config.productionTip = false

/* eslint-disable no-new */
let root = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data () {
    return {
      Permission: JSON.parse(sessionStorage.getItem('Permission')),
      openNav: [],
      PerList: JSON.parse(sessionStorage.getItem('PerList')),
      loginInfo: JSON.parse(sessionStorage.getItem('loginInfo')),
      imgUrl: imgUrl,
      isShowHeaderOpera: false
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {
    format(val) {
      if (!val) return false;
      let time = new Date(val), year = time.getFullYear(), month = (time.getMonth()+1), day = time.getDate();
      if (month < 10) {
        month = '0' + month;
      } 
      if (day <10) {
        day = '0' +day;
      }
      return year + '-' +  month + '-' + day;
    },
    //验证是否有权限
    VERIFYPERMISSION (val) {
      //console.log(val)
      let bl = false;
      this.PerList.forEach(element => {
        if (element === val) {
          bl = true
          return
        }
      })
      return bl
    },
    setTime() {
      function getDay(year, month) {
				if (month === '04' || month === '06' || month === '09' || month === '11') {
					return '30'
				} else if (month === '02') {
					if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
						return '29'
					} else {
						return '28'
					}
				} else {
					return '31'
				}
      }
      let nowTime = this.moment(new Date()).format('YYYY-MM-DD').split('-'), start, end
      if (nowTime[2] * 1 === 1) {
				if (nowTime[1] * 1 === 1) {
					nowTime[1] = '12'
					nowTime[0] = nowTime[0] * 1 - 1
					start = nowTime.join('-').split('-')
					start[2] = '01'
					start = start.join('-')
					end = nowTime.join('-').split('-')
					end[2] = getDay(end[0], end[1])
					end = end.join('-')
				} else {
					nowTime[1] = nowTime[1] * 1 - 1
					nowTime[1] < 10 ? (nowTime[1] = '0' + nowTime[1]) : nowTime[1]
					start = nowTime.join('-').split('-')
					start[2] = '01'
					start = start.join('-')
					end = nowTime.join('-').split('-')
					end[2] = getDay(end[0], end[1])
					end = end.join('-')
				}
			} else {
				start = nowTime.join('-').split('-')
				start[2] = '01'
				start = start.join('-')
				end = nowTime.join('-').split('-')
				end[2] = end[2] * 1 - 1
				end[2] < 10 ? (end[2] = '0' + end[2]) : end[2]
				end = end.join('-')
			}
			return [start, end]
    }
  },
  mounted(){

  }
})

//过滤器
//时间格式化
Vue.filter('data', val => {
  if (val !== undefined) {
    return moment(val).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
})
//金额格式化两位小数
Vue.filter('fixed2', val => {
	return Number(val).toFixed(2)
})

Vue.prototype.success = function (text) {
  root.$message({
    message: text,
    type: 'success'
  })
}

Vue.prototype.error = function (text) {
	root.$message.error(text)
}

Vue.prototype.update = function (text) {
	this.$forceUpdate()
}

Vue.prototype.goPath = function (path) {
	this.$router.push({path: path})
}

Vue.prototype.educe = function (url, name) {
  const newUrl = url.replace('http:','https:')
	let temp = document.createElement("a")
  temp.style.display = "none"
	temp.href = newUrl
  temp.setAttribute("download", name)
  document.body.appendChild(temp)
  temp.click()
  document.body.removeChild(temp)
}


// WEBPACK FOOTER //
// ./src/main.js